<template>
  <div class="guid-page" >
    <!-- <div class="container"> -->
      <div class="guid-logo">
        <p class="logo-pic"><img src="../assets/images/logo1-w.png" alt="广东省文化馆" style="height:45px"></p>
        <p class="logo-pic"><img src="../assets/images/logo2-w.png" alt=""></p>
      </div>
      <div class="guid-music" :style="[{'animation-play-state':musicPl},{backgroundImage:'url('+music +')'}]" @click="clickAudio">
        
      </div>
      <div class="guid-mouse"  :style="{backgroundImage:'url('+mouse +')'}" @click="goHome"></div>
      <div class="audio">
        <audio style="height: 0" id="bgm" preload="auto" autoplay :src="bgm" loop></audio>
      </div>
      <div class="guid-content">
        <div class="guid-title">
          <img src="../assets/images/guid_title.png" alt="">
        </div>
        <div  class="about-content" v-html="aboutContent" v-if="aboutContent"></div>
      </div>
      
    <!-- </div> -->
  </div>
</template>

<script>
import guidBg from '../assets/images/guidbg.jpg'
import music from '../assets/images/music.png'
import mouse from '../assets/images/mouse.png'
import logo1W from '../assets/images/logo1-w.png'
import logo2W from '../assets/images/logo2-w.png'
import bgm from '../assets/mp3/bgm.mp3'
import { mapState,mapActions } from 'vuex'
export default {
  components: {   },
  name: 'guid',
  props: {
    msg: String
  },
  data(){
    return{
      guidBg,music,mouse,logo1W,logo2W,bgm,
      musicState:true,
      musicPl:'',

    }
  },
  computed:{
    ...mapState(['aboutContent'])
  },
  mounted() {
    if(!this.aboutContent ){
        this.getAbout()
      }
     // 播放音乐
    let oAudio = document.querySelector("#bgm");
    oAudio.onended = function() {
      //播放完毕，重新循环播放
      oAudio.load();
      oAudio.play();
    };
    this.audioAutoPlay();
    console.log(this.$route.path)
    if( this.$route.path=="/guid"){
      if(document.addEventListener){  
        // document.addEventListener('mousewheel',this.scrolls,false);
        window.addEventListener('mousewheel',this.scrolls,false)
        window.addEventListener("DOMMouseScroll",this.scrolls,false)
      }//W3C  
      // window.onmousewheel=document.onmousewheel=this.scrolls();//IE/Opera/Chrome
      // console.log("鼠标滚动")
    }
    
    this.$api.recordApi.addListRecord('首页')
  },
  destroyed() {
    document.removeEventListener("mousewheel", this.scrolls,false);
    document.removeEventListener("DOMMouseScroll", this.scrolls,false);
    this.stopAudio()
  },
  methods: {
    ...mapActions(["getAbout"]),
    audioAutoPlay(){
      let audio = document.getElementById("bgm");
      audio.play();
      this.musicState = true;
      if(audio.paused){
        this.stopAudio()
      }
      document.removeEventListener("touchstart", this.audioAutoPlay);
    },

    clickAudio(){
      let audio = document.getElementById("bgm");
      if(audio.paused){
        this.playAudio()
      }else{
        this.stopAudio()
      }
    },
    playAudio(){
      this.musicState = true;
      this.musicPl = 'running';
      let audio = document.getElementById("bgm");
      audio.play();

    },
    stopAudio(){
      this.musicState = false;
      this.musicPl = 'paused';
       let audio = document.getElementById("bgm");
      audio.pause();
    },
    scrolls(e){
      let num = e.deltaY ? e.deltaY :e.detail;
      if(this.$route.path=='/guid'&& num >0){
        this.goHome();
        this.stopAudio();
      }else{
        return false;
      }
    },
    goHome(){
      this.$router.push({path:"/index"})
      
    },


  },
}
</script>
<style  >
@import url(../assets/css/guid.css);
</style>